/**
 * Sticky header custom element.
 */
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.getElementById('shopify-section-header');
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
    this.createHumbergerDup();
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.header.classList.add('shopify-section-header-sticky');
    document.body.classList.remove('header-sticky-scrollup');
    document.body.classList.add('header-sticky-scrolldown');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    document.body.classList.add('header-sticky-scrollup');
    document.body.classList.remove('header-sticky-scrolldown');
  }

  reset() {
    this.header.classList.remove('shopify-section-header-sticky', 'animate');
    document.body.classList.remove('header-sticky-scrollup');
    document.body.classList.remove('header-sticky-scrolldown');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => {
      if (this.disclosures != null) {
        disclosure.close();
      }
    });
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    if (this.searchModal != null) {
      this.searchModal.close(false);
    }
  }

  createHumbergerDup() {
    const originalHeaderDrawer = document.querySelector('header-drawer[data-breakpoint="tablet"]');
    let targetElement = document.querySelector('#custom-header > .header__heading');

    if (!targetElement) {
      targetElement = document.querySelector('#custom-header > a.header__heading-link');
    }

    if (originalHeaderDrawer && targetElement) {
      const clonedHeaderDrawer = originalHeaderDrawer.cloneNode(true);
      clonedHeaderDrawer.classList.add('custom-header-mobile-drawer');
      targetElement.parentNode.insertBefore(clonedHeaderDrawer, targetElement);
      originalHeaderDrawer.style.display = 'none';
    }
  }
}

customElements.define('sticky-header', StickyHeader);
